import 'babel-polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import jQuery from 'jquery'
import Router from 'vue-router'
import * as VueGoogleMaps from 'vue2-google-maps'
import VModal from 'vue-js-modal'
import App from './App.vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import '../src/assets/scss/main-theme.scss'
import router from './routes';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAFN6T9RwgQ8dEGKzI9QvvXxeC7Bj6z9ME',
    libraries: 'geometry,places',
    v: '3.41'
  },
  autobindAllEvents: true,
  installComponents: true,
})
Vue.use(Router)
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false } })
Vue.use(VueLodash, { lodash: lodash })
Vue.config.productionTip = false
declare global {
  interface Vue {
    $gmap: any
    window: any
  }
}
declare global {
  interface Window {
    jQuery: any
    $: any
  }
}
window.jQuery = window.$ = jQuery


new Vue({
  render: (h) => h(App),
  router,
}).$mount('#app')